import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { logoutAdmin } from '../../store/actions/adminActions';
import { fetchPaintings } from '../../store/actions/paintingsActions';
import { useNavigate, Link, Outlet, useLocation } from 'react-router-dom';
import PaintingList from "../../components/Painting/PaintingList";
import usePageTitle from '../../hooks/usePageTitle';

const AdminDashboard = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const { admin } = useSelector((state) => state.adminState);
    const { paintings, loading, error, hasLoaded } = useSelector((state) => state.paintingsState);

    usePageTitle("Admin | Dinara Fariz");

    useEffect(() => {
        if (!admin) {
            navigate('/login');
        }
    }, [admin, navigate]);

    // Грузим список только если он ещё ни разу не загружался в этой сессии.
    // Мутации (create/update/delete/move) держат Redux актуальным через свои
    // fulfilled-редьюсеры, а backend возвращает полный документ — поэтому
    // повторный GET при возврате на /admin из add/edit не нужен. F5/прямой
    // заход сбрасывают стор → hasLoaded=false → загрузка выполнится.
    useEffect(() => {
        if (!hasLoaded) {
            dispatch(fetchPaintings());
        }
    }, [dispatch, hasLoaded]);

    const handleLogout = () => {
        dispatch(logoutAdmin()).then(() => {
            navigate('/login');
        });
    };

    const isListPage = location.pathname === '/admin';

    return (
        <div className="max-w-6xl mx-auto px-4 md:px-6 py-4 md:py-12">
            <div className="mb-8 md:mb-10 pb-5 border-b border-gray-200">
                <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                    <div className="space-y-1">
                        <h1 className="text-xl md:text-2xl font-light uppercase tracking-[0.25em] text-gray-800">
                            Admin
                        </h1>
                        <p className="text-xs uppercase tracking-[0.2em] text-gray-400">
                            Dinara Fariz
                        </p>
                    </div>

                    <button
                        onClick={handleLogout}
                        className="self-start md:self-auto text-sm uppercase tracking-[0.2em] text-gray-500 hover:text-black transition"
                    >
                        Logout
                    </button>
                </div>
            </div>

            <div className="flex flex-wrap gap-4 mb-10 border-b border-gray-200 pb-4">
                <Link
                    to="/admin"
                    className={`text-sm uppercase tracking-[0.2em] pb-1 border-b transition ${
                        isListPage
                            ? 'border-black text-black'
                            : 'border-transparent text-gray-500 hover:text-black hover:border-gray-400'
                    }`}
                >
                    Paintings
                </Link>

                <Link
                    to="/admin/add"
                    className={`text-sm uppercase tracking-[0.2em] pb-1 border-b transition ${
                        location.pathname === '/admin/add'
                            ? 'border-black text-black'
                            : 'border-transparent text-gray-500 hover:text-black hover:border-gray-400'
                    }`}
                >
                    Add Painting
                </Link>
            </div>

            <div>
                {isListPage ? (
                    <>
                        {loading ? (
                            <div className="text-center py-10 text-gray-500">
                                Loading...
                            </div>
                        ) : error ? (
                            <div className="text-center py-10 text-red-600">
                                Error: {error}
                            </div>
                        ) : (
                            <PaintingList paintings={paintings} />
                        )}
                    </>
                ) : (
                    <Outlet />
                )}
            </div>
        </div>
    );
};

export default AdminDashboard;